import React from "react";
import { NavLink } from "react-router-dom";

function NewProfileButton(props) {
  return (
    <div>
      <br />
      <NavLink className="NewProfileButton hoverBox" to="/newReport">
        Add New Report
      </NavLink>
      <br />
      <br />
    </div>
  );
}

export default NewProfileButton;
